
import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] flex justify-center px-4 pb-4"
      style={{
        animation: 'slideUp 0.4s ease forwards',
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div className="w-full max-w-4xl bg-white border border-gray-200 rounded-xl shadow-xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icono */}
        <div className="w-10 h-10 flex items-center justify-center bg-[#1A2B4A]/8 rounded-lg flex-shrink-0">
          <i className="ri-cookie-line text-[#1A2B4A] text-xl"></i>
        </div>

        {/* Texto */}
        <p className="flex-1 text-sm text-gray-600 leading-relaxed">
          Este sitio web utiliza cookies técnicas necesarias para garantizar el correcto funcionamiento y navegación. Puedes obtener más información en nuestra{' '}
          <a
            href="/politica-cookies"
            className="text-[#1A2B4A] font-medium hover:underline cursor-pointer"
          >
            Política de Cookies
          </a>
          .
        </p>

        {/* Botón */}
        <button
          onClick={handleAccept}
          className="flex-shrink-0 px-6 py-2.5 bg-[#1A2B4A] text-white text-sm font-semibold rounded-lg hover:bg-[#243550] transition-colors cursor-pointer whitespace-nowrap"
        >
          Aceptar
        </button>
      </div>
    </div>
  );
}
